import { getStore } from '../store/store';
import type { FolderForestNode } from 'owa-favorites-types';

export default function getPreviousNode(): FolderForestNode | undefined {
    return getStore().previousNode;
}
